import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import _ from 'lodash';

import SideMenu from '../../components/SideMenu';
import style from './style.scss';

@inject('docsStore')
@observer
export default class Main extends Component {

  static propTypes = {
    children: PropTypes.any,
    params: PropTypes.object,
    location: PropTypes.object,
    docsStore: PropTypes.object,
  }

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      version: '',
      components: [],
      props: [],
      propsByComponentId: {},
      selectedComponentIndex: 0,
    };

    this.selectComponent = this.selectComponent.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  selectComponent(index) {
    this.setState({
      selectedComponentIndex: index,
    });
  }

  renderContent() {
    const {components, propsByComponent} = this.props.docsStore;
    const {params, children} = this.props;
    const {componentId} = params;
    if (componentId) {
      const component = _.find(components, component => component.displayName === componentId);
      const props = propsByComponent[component.displayName];
      return children && React.cloneElement(children, {component, props});
    }

    return children;
  }

  render() {
    const {isLoading, components, version} = this.props.docsStore;
    const {location} = this.props;
    if (isLoading) {
      return (
        <div className={`${style.page} ${style.loading}`}>
          <h1>
            Loading Components...
          </h1>
        </div>
      );
    }

    return (
      <div className={style.main}>
        <SideMenu components={components} location={location} version={version}/>
        <div className={style.content}>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./containers/Main/index.js